import { AutogenLayoutMobileCommControlActive } from "./autogen/AutogenLayoutMobileCommControlActive";

export class MobileCommControlActive extends AutogenLayoutMobileCommControlActive {

    async onLoad() {
    }
}
